import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import VerifyPaymentModal from "./VerifyPaymentModal";
import PaymentSuccessModal from "./PaymentSuccessModal";
import PaymentProgressModal from "./PaymentProgressModal";
import { VerifyPayment, GetWalletAmount } from "../../services/api";
import { useDispatch } from "react-redux";
import { updateUser } from "../../features/auth/authSlice";

const UpiPayment = ({ orderId, upiId, name, amount, intentUrl }) => {

    const [openVerify, setOpenVerify] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showProgress, setShowProgress] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const qrRef = useRef(null);

    console.log("orderId ", orderId);
    console.log("Intent Url ", intentUrl);

    const downloadQR = () => {
        const canvas = qrRef.current?.querySelector("canvas");
        if (!canvas) return;

        const image = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = image;
        link.download = "upi_qr_code.png";
        link.click();
    };

    const copyText = (text) => {
        navigator.clipboard.writeText(text);
    };

    const OnVerifyPaymentClick = () => {
        console.log("Verify Payment");
        setOpenVerify(true);
    };

    const handleVerify = async (data) => {

        console.log("VERIFY DATA", data);
        setOpenVerify(false);

        const payload =
        {
            orderId,
            upipayload: {
                "utr": data?.utr,
                "transactionId": data?.txnId,
                "upiId": data?.upiId,
                "payerUpiHolderName": data?.holderName
            }
        };

        const verifyPaymentRes = await VerifyPayment(payload);
        const verifyData = verifyPaymentRes?.data;

        if (verifyData?.success) {
            setShowSuccess(true);

            const walletRes = await GetWalletAmount();
            dispatch(updateUser({ walletBalance: walletRes?.data?.walletBalance }));
        } else {
            setShowProgress(true);
        }
    };

    const OnHandleSuccessOrFail = async () => {
        setShowSuccess(false);
        setShowProgress(false);
        navigate("/explore");
    };

    return (
        <div className="min-h-screen bg-[#F5F7FA] flex justify-center px-4 py-10 mt-12">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-sm p-6 text-center">

                {/* Title */}
                <h1 className="text-[22px] font-bold text-[#0F172A]">
                    Red Video Chat
                </h1>

                {/* QR */}
                <div
                    ref={qrRef}
                    className="flex justify-center p-4"
                >
                    <QRCodeCanvas value={intentUrl} size={240} level="H" />
                </div>

                {/* Amount */}
                <p className="text-[#334155] text-lg font-medium mb-4">
                    Amount: {amount}
                </p>

                <p className="text-sm text-[#64748B] mb-2">
                    Name:
                    <span className="font-semibold text-[#0F172A] ml-1">
                        {name}
                    </span>
                </p>

                <p className="text-sm text-[#64748B] mb-4">
                    UPI ID:
                    <span className="font-semibold text-[#0F172A] ml-1">
                        {upiId}
                    </span>
                </p>

                {/* Instruction */}
                <p className="text-sm text-[#64748B] mb-5">
                    Scan the QR code or use an option below
                </p>

                {/* Tip */}
                <p className="text-xs text-[#94A3B8] mb-4">
                    If you deposit wrong amount then your amount will be lost
                </p>

                <div className="flex gap-3 mb-4">
                    <a
                        href={intentUrl}
                        className="flex-1 bg-[#22C55E] text-white py-3 rounded-xl font-semibold text-center"
                    >
                        Open in UPI App
                    </a>

                    <button
                        onClick={() => copyText(upiId)}
                        className="flex-1 bg-[#6B7280] text-white py-3 rounded-xl font-semibold"
                    >
                        Copy UPI ID
                    </button>
                </div>

                {/* Tip */}
                <p className="text-xs text-[#94A3B8] mb-4">
                    Tip: If "Open" doesn’t work, copy the UPI ID and paste it into your app.
                </p>

                <button
                    onClick={downloadQR}
                    className="w-full bg-[#3B82F6] text-white py-3 rounded-xl font-semibold mb-4"
                >
                    Download QR Code
                </button>

                <p className="text-xs text-[#94A3B8] mb-4">
                    When your payment is done then click below to verify your payment
                </p>

                <button
                    onClick={OnVerifyPaymentClick}
                    className="w-full bg-[#22C55E] text-white py-3 rounded-xl font-semibold mb-4"
                >
                    Verify Payment
                </button>

            </div>

            <VerifyPaymentModal
                open={openVerify}
                onClose={() => setOpenVerify(false)}
                onSubmit={(data) => { handleVerify(data) }}
            />

            <PaymentSuccessModal
                open={showSuccess}
                onClose={OnHandleSuccessOrFail}
            />

            <PaymentProgressModal
                open={showProgress}
                onClose={OnHandleSuccessOrFail}
            />

        </div>
    );
};

export default UpiPayment;